module.exports = __webpack_public_path__ + "img/jd.fb5a5d41.png";